/**
 * Copy und Beispieldaten für das Scrollytelling.
 * Interne Showcase-Seite, deshalb nur Deutsch und ohne i18n.
 * Lena und Mara sind fiktiv, alle Zahlen sind Beispielwerte.
 */

export const SIDES = {
  hr: { label: 'Kundenseite', person: 'Mara' },
  talent: { label: 'Talentseite', person: 'Lena' },
  both: { label: 'Beide Seiten', person: 'Mara und Lena' }
}

export const HERO = {
  eyebrow: 'Eine Bewerbung, zwei Perspektiven',
  title: 'Von der Bewerbung bis zur Zusage',
  text: 'Scroll durch die Geschichte von Lena und Mara. Lena bewirbt sich, Mara sucht die passende Person. Aivy bringt beide zusammen, wissenschaftlich fundiert und nachvollziehbar.',
  cue: 'Scroll los'
}

export const CHAPTERS = [
  {
    id: 'stelle',
    side: 'hr',
    label: 'Die Stelle',
    steps: [
      {
        title: 'Alles beginnt mit einer Frage',
        text: 'Mara sucht Verstärkung für den Vertrieb. Bevor die erste Bewerbung eintrifft, klärt sie, was die neue Person wirklich können muss.'
      },
      {
        title: 'Drei Blickwinkel, ein gemeinsames Bild',
        text: 'Mara startet mit einer Aivy-Vorlage und lädt drei Kolleg:innen aus dem Fachbereich zur Anforderungsanalyse ein. Jede Person braucht 5 bis 10 Minuten, und am Ende sprechen alle dieselbe Sprache.'
      },
      {
        title: 'Ideal- und Übergangsbereich',
        text: 'Aivy verdichtet die Einschätzungen zu einem Anforderungsprofil nach den Best Practices der DIN 33430. Für jede Dimension gibt es einen Ideal- und einen Übergangsbereich, so weiß Mara vorher, worauf es ankommt.'
      }
    ]
  },
  {
    id: 'einladung',
    side: 'talent',
    label: 'Die Einladung',
    steps: [
      {
        title: 'Lena bekommt eine Einladung',
        text: 'Lena hat sich auf die Stelle beworben. Statt eines weiteren Formulars bekommt sie einen Link zum Game-based Assessment.'
      },
      {
        title: 'Wann und wo es ihr passt',
        text: 'Lena startet am Smartphone oder im Browser. Sie sieht vorab, welche Aufgaben sie erwarten, und kann ganz entspannt loslegen.'
      }
    ]
  },
  {
    id: 'spiele',
    side: 'talent',
    label: 'Warum Spiele?',
    steps: [
      {
        title: 'Spielen statt ankreuzen',
        text: 'Lena löst kurze, spielerische Aufgaben. Dabei zählt, wie sie handelt und entscheidet, nicht wie sie sich selbst beschreibt.'
      },
      {
        title: 'Wissenschaft im Hintergrund',
        text: 'Hinter jedem Spiel steckt ein Verfahren aus der Eignungsdiagnostik, vom Codeknacker bis zum Dreamteam. Zusammen messen sie Fähigkeiten, Persönlichkeit, Kultur und berufliche Interessen.'
      },
      {
        title: 'Fühlt sich nicht wie eine Prüfung an',
        text: 'Wer entspannt ist, zeigt eher, was in einem steckt. Und nach wenigen Minuten ist alles erledigt.'
      }
    ]
  },
  {
    id: 'feedback',
    side: 'talent',
    label: 'Feedback für Lena',
    steps: [
      {
        title: 'Lena geht nicht leer aus',
        text: 'Direkt nach dem letzten Spiel sieht Lena ihr persönliches Stärkenprofil. Egal wie die Bewerbung ausgeht, sie nimmt etwas für sich mit.'
      }
    ]
  },
  {
    id: 'passung',
    side: 'hr',
    label: 'Die Passung',
    steps: [
      {
        title: 'Mara sieht die Passung',
        text: 'Lenas Ergebnisse landen direkt im Dashboard. Für jede Dimension sieht Mara, ob Lena im Ideal- oder im Übergangsbereich liegt.'
      },
      {
        title: 'Das Passungsprofil als PDF',
        text: 'Die Passung entsteht aus dem Abgleich von Ergebnis und Anforderungsprofil. Im ausführlichen Passungsprofil sieht Mara genau, warum Lena hier bei 64 % landet, mit Chancen, Risiken und Interviewfragen.'
      },
      {
        title: 'Glass Box statt Black Box',
        text: 'Im Kern rechnet Aivy ohne KI. Bei Personalentscheidungen muss klar sein, wie ein Ergebnis zustande kommt. Ein Modell, dem man einfach glauben muss, reicht dafür nicht.'
      }
    ]
  },
  {
    id: 'assistent',
    side: 'hr',
    label: 'KI als Erklärhilfe',
    steps: [
      {
        title: 'Fragen statt suchen',
        text: 'Das Passungsprofil ist das Kernstück. Der Aivy Assistent ist ein Hilfsmittel dazu, er übersetzt die Ergebnisse in klare Sprache und beantwortet Maras Fragen.'
      },
      {
        title: 'Vorbereitet ins Gespräch',
        text: 'Auf Wunsch schlägt der Assistent Interviewfragen vor, genau zu den Punkten, die Mara vertiefen möchte.'
      },
      {
        title: 'Die KI erklärt, sie entscheidet nicht',
        text: 'Die Passung bleibt regelbasiert und unverändert. Die KI macht sie nur leichter verständlich und gibt Mara einen Tipp für den nächsten Schritt.'
      }
    ]
  },
  {
    id: 'kreuzmatching',
    side: 'both',
    label: 'Kreuzmatching',
    steps: [
      {
        title: 'Passt nicht? Passt vielleicht woanders.',
        text: 'Für den Vertrieb reicht es knapp nicht. Statt Lena abzusagen, startet Mara ein Kreuzmatching.'
      },
      {
        title: 'Ein Ergebnis, alle Stellen',
        text: 'Aivy gleicht Lenas Ergebnis mit den Anforderungsprofilen aller offenen Stellen ab. Ohne neues Assessment und ohne Wartezeit.'
      },
      {
        title: '91 % für Customer Success',
        text: 'Im Customer-Success-Team passt Lena hervorragend. Ein Talent, das sonst durchs Raster gefallen wäre.'
      }
    ]
  },
  {
    id: 'sicherheit',
    side: 'hr',
    label: 'Sicherheit für HR',
    steps: [
      {
        title: 'Sicher von Anfang an',
        text: 'Alle Daten liegen auf ISO-27001-zertifizierten Servern in Deutschland. Aivy arbeitet DSGVO-konform.'
      },
      {
        title: 'Du behältst die Kontrolle',
        text: 'Talente werden nach der von dir gewählten Frist automatisch gelöscht. Den Passungsscore kannst du im Report ausblenden, wenn du das möchtest.'
      },
      {
        title: 'Entscheidungen, die du begründen kannst',
        text: 'Anforderungsanalyse nach DIN 33430, wissenschaftlich fundierte Verfahren und eine nachvollziehbare Berechnung. So steht jede Auswahl auf festem Boden.'
      }
    ]
  },
  {
    id: 'daten',
    side: 'hr',
    label: 'Daten für HR',
    steps: [
      {
        title: 'Alles auf einen Blick',
        text: 'Mara sieht, wer eingeladen ist, wer abgeschlossen hat und wie sich die Passung über alle Talente verteilt.'
      },
      {
        title: 'Jede Besetzung macht die nächste leichter',
        text: 'Die Daten zeigen, welche Profile zu welchen Stellen passen. So wird Recruiting mit jeder Stelle ein Stück planbarer.'
      }
    ]
  },
  {
    id: 'zusage',
    side: 'both',
    label: 'Die Zusage',
    steps: [
      {
        title: 'Ein Match, zwei Gewinnerinnen',
        text: 'Lena startet als Customer Success Managerin. Mara hat eine Stelle besetzt, an die zu Beginn niemand gedacht hat.'
      }
    ]
  }
]

export const OUTRO = {
  title: 'So funktioniert Aivy',
  points: [
    'Anforderungen objektiv definieren',
    'Stärken game-based messen',
    'Passung nachvollziehbar berechnen',
    'Mit KI verstehen, mit Kreuzmatching weiterdenken'
  ],
  primary: { label: 'Stelle anlegen', to: '/career/new' },
  secondary: 'Nochmal von vorn'
}

// ---------- Beispieldaten ----------

export const JOB = 'Kundenberater:in Vertrieb'

export const EXPERTS = [
  {
    initials: 'SK',
    name: 'Sven K.',
    role: 'Teamleitung Vertrieb',
    color: 'yellow'
  },
  {
    initials: 'AB',
    name: 'Aylin B.',
    role: 'Senior Beraterin',
    color: 'green'
  },
  { initials: 'TW', name: 'Tim W.', role: 'Bereichsleitung', color: 'pink' }
]

// Werte in Prozent der Skala, wie im PDF-Report: ideal = Idealbereich,
// trans = Übergangsbereich, experts = Einschätzungen, lena = Ergebnis
export const DIMENSIONS = [
  {
    name: 'Merkfähigkeit',
    ideal: [45, 75],
    trans: [35, 85],
    experts: [52, 60, 70],
    lena: 68
  },
  {
    name: 'Emotionswahrnehmung',
    ideal: [55, 88],
    trans: [45, 95],
    experts: [60, 72, 84],
    lena: 86
  },
  {
    name: 'Gewissenhaftigkeit',
    ideal: [50, 80],
    trans: [40, 90],
    experts: [56, 66, 74],
    lena: 74
  },
  {
    name: 'Extraversion',
    ideal: [62, 90],
    trans: [50, 96],
    experts: [66, 78, 86],
    lena: 34
  },
  {
    name: 'Risikobereitschaft',
    ideal: [56, 84],
    trans: [42, 92],
    experts: [60, 70, 80],
    lena: 47
  }
]

// Stufen wie in der Legende des Passungsprofils
export const fitOf = (d) =>
  d.lena >= d.ideal[0] && d.lena <= d.ideal[1]
    ? 'high'
    : d.lena >= d.trans[0] && d.lena <= d.trans[1]
      ? 'mid'
      : 'low'

export const FIT_LABELS = {
  high: 'Hohe Passung',
  mid: 'Mittlere Passung',
  low: 'Niedrige Passung'
}

export const MATCH_SCORE = 64

export const CROSS_JOBS = [
  'Vertrieb',
  'Customer Success',
  'Innendienst',
  'Teamassistenz'
]
export const CROSS_TALENTS = [
  { name: 'Lena K.', values: [64, 91, 78, 70], highlight: true },
  { name: 'Jonas M.', values: [87, 62, 70, 55] },
  { name: 'Aylin S.', values: [72, 80, 84, 66] },
  { name: 'Tom B.', values: [58, 66, 61, 82] }
]

export const STRENGTHS = [
  {
    shape: 'dot',
    color: 'pink',
    title: 'Empathie',
    text: 'Du erkennst schnell, wie es anderen geht.'
  },
  {
    shape: 'tri',
    color: 'yellow',
    title: 'Vorausplanen',
    text: 'Du denkst mehrere Schritte voraus.'
  },
  {
    shape: 'sq',
    color: 'green',
    title: 'Merkfähigkeit',
    text: 'Du behältst viele Details im Kopf.'
  }
]

export const CHAT = {
  q1: 'Warum passt Lena nur zu 64 % auf die Stelle?',
  a1: 'Bei Merkfähigkeit, Emotionswahrnehmung und Gewissenhaftigkeit liegt Lena im Idealbereich. Risikobereitschaft liegt im Übergangsbereich, Extraversion deutlich darunter. Für eine Vertriebsrolle mit viel Neukundengewinnung fällt das ins Gewicht.',
  q2: 'Was sollte ich im Interview vertiefen?',
  a2: [
    'Erzähl von einer Situation, in der du jemanden von etwas Neuem überzeugt hast.',
    'Wie gehst du vor, wenn du eine Entscheidung ohne alle Infos treffen musst?'
  ],
  tip: 'Tipp: Lenas Stärken passen gut zu Rollen mit viel Kundenkontakt. Mit dem Kreuzmatching prüfst du sie auf alle offenen Stellen.'
}

// Spiele aus dem Game-based Assessment, Namen wie auf aivy.app/ausprobieren
export const GAMES = [
  { kind: 'sq', color: 'green', title: 'Codeknacker', dim: 'Merkfähigkeit' },
  {
    kind: 'dot',
    color: 'pink',
    title: 'Gefühlschaos',
    dim: 'Emotionswahrnehmung'
  },
  { kind: 'tri', color: 'yellow', title: 'Dreamteam', dim: 'Kultur' }
]
